import {ILocalStorageServiceConfig} from 'angular-2-local-storage';
/**
 * Created by Rodrigo Quesada on 27/03/17.
 */

export const config: ILocalStorageServiceConfig = {
    prefix: 'my-app',
    storageType: 'localStorage'
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/infrastructure/local-storage/local-storage.config.ts